<template>
  <div :class="[{ active: active }, 'spinner']">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
/**
 * @class Spinner
 *
 * @description and the world is just spinning around...
 */
export default {
  name: 'Spinner',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.active.spinner {
  display: inline-block;
  position: relative;
  width: 1rem;
  height: 1rem;
}
.active.spinner div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 1.2rem;
  height: 1.2rem;
  border: 0.3rem solid #fff;
  border-radius: 50%;
  animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.active.spinner div:nth-child(1) {
  animation-delay: -0.45s;
}
.active.spinner div:nth-child(2) {
  animation-delay: -0.3s;
}
.active.spinner div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
